<template>
    <div class="Hosting" v-if="RecordData.Id">
        <div class="container-fluid">
            <div class="row" v-if="!OperationsAllowed">
                <div class="col">
                    <p>
                        <i class="fa fa-exclamation red" /> You can view Past Hosting Information but can not make changes.  Changes to Hostings are only permitted for Active Referrals.
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="record-section">
                        <h3>CHILDREN NOT CURRENTLY HOSTED</h3>
                        <table class="table-utility">
                            <thead>
                                <tr>
                                    <th v-if="OperationsAllowed"></th>
                                    <th>Name</th>
                                    <th>Age</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="child in UnhostedChildren">
                                    <td v-if="OperationsAllowed">
                                        <b-form-checkbox :value="true" v-model="child.Checked" size="lg"></b-form-checkbox>
                                    </td>
                                    <td>{{ child.FullName }}</td>
                                    <td>{{ child.AgeString }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <b-button v-if="UnhostedChecked" size="md" variant="success" type="button" class="form-control" @click="ShowStartHosting()" style="margin-top: 10px;">
                            <i class="fa fa-home" /> START HOSTING FOR SELECTED CHILDREN
                        </b-button>
                    </div>
                </div>
                <div class="col">
                    <div class="record-section">
                        <h3>HOSTINGS IN PROGRESS</h3>
                        <table class="table-utility">
                            <thead>
                                <tr>
                                    <th v-if="OperationsAllowed"></th>
                                    <th>Child</th>
                                    <th>Age</th>
                                    <th>Host Family</th>
                                    <th>Started</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="hosting in CurrentHostings">
                                    <td v-if="OperationsAllowed">
                                        <b-form-checkbox :value="true" v-model="hosting.Checked" size="lg"></b-form-checkbox>
                                    </td>
                                    <td>{{ hosting.Client.Person.FullName }}</td>
                                    <td>{{ hosting.Client.Person.AgeString }}</td>
                                    <td>{{ hosting.FosterResourceFamily.Name }}</td>
                                    <td>{{ formatDate(hosting.StartDate, 'MM/DD/YY') }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="row" v-if="OperationsAllowed">
                            <div class="col">
                                <b-button v-if="HostedChecked" size="md" variant="success" type="button" class="form-control" @click="ShowEndHosting()" style="margin-top: 10px;">
                                    <i class="fa fa-home" /> END HOSTING FOR SELECTED CHILDREN
                                </b-button>
                            </div>
                            <div class="col">
                                <b-button v-if="HostedChecked" size="md" variant="danger" type="button" class="form-control" @click="ShowDeleteHosting()" style="margin-top: 10px;">
                                    <i class="fa fa-trash" /> DELETE HOSTING FOR SELECTED CHILDREN
                                </b-button>
                            </div>
                        </div>




                    </div>

                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="record-section">
                        <h3>
                            CHURCH CONTACTS ASSOCIATED WITH CURRENT HOSTINGS
                        </h3>
                        <table class="table-utility">
                            <thead>
                                <tr>
                                    <th>Host Family</th>
                                    <th>Church Name</th>
                                    <th>Contacts</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="church in ChurchContacts">
                                    <td>{{ church.FosterResourceFamilyName }}</td>
                                    <td>{{ church.ChurchName }}</td>
                                    <td>
                                        <div v-for="churchcontact in church.ContactInfos" class="small-margin-p-block" style="margin-bottom:10px;">
                                            <p class="bold underline"><span v-if="churchcontact.NotifyOfHostings"><i class="fa fa-star olive-green-text" /></span> {{churchcontact.Name}}, {{churchcontact.Role}}:</p>
                                            <p style="padding-left:15px;"><a :href="'mailto:' + churchcontact.Email">{{churchcontact.Email}}</a></p>
                                            <p style="padding-left:15px;">{{churchcontact.Phone}}</p>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="record-section">
                        <h3>HOSTING HISTORY FOR THIS ENGAGEMENT</h3>
                        <table class="table-utility">
                            <thead>
                                <tr>
                                    <th v-if="OperationsAllowed"></th>
                                    <th>Child</th>
                                    <th>Age</th>
                                    <th>Host Family</th>
                                    <th>Started</th>
                                    <th>Ended</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="hosting in HostingHistory">
                                    <td v-if="OperationsAllowed">
                                        <b-form-checkbox :value="true" v-model="hosting.Checked" size="lg"></b-form-checkbox>
                                    </td>
                                    <td>{{ hosting.Client.Person.FullName }}</td>
                                    <td>{{ hosting.Client.Person.AgeString }}</td>
                                    <td>{{ hosting.FosterResourceFamily.Name }}</td>
                                    <td>{{ formatDate(hosting.StartDate, 'MM/DD/YY') }}</td>
                                    <td>{{ formatDate(hosting.EndDate, 'MM/DD/YY') }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="row" v-if="OperationsAllowed">
                            <div class="col">

                            </div>
                            <div class="col">
                                <b-button v-if="HistoryChecked" size="md" variant="danger" type="button" class="form-control" @click="ShowDeleteHosting()" style="margin-top: 10px;">
                                    <i class="fa fa-trash" /> DELETE HOSTING FOR SELECTED CHILDREN
                                </b-button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>

        <!--Start Hosting-->
        <b-modal ref="modal-start-hosting" size="lg" title="Start a Hosting" hide-footer>
            <b-container>
                <b-form @submit="HostSelectedChildren">
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Hosting Start Date:</label>
                                <flat-pickr v-model="EffectiveDate" class="form-control" required :config="DateConfig"></flat-pickr>
                            </div>
                        </b-col>
                        <b-col>
                            <div class="form-group">
                                <label>Host Family:</label>
                                <v-select :options="HostFamilyOptionsDataAccess" label="text" required :reduce="option => option.value" v-model="TargetResourceFamily.TargetFosterResourceFamily"></v-select>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelStartHosting()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                START HOSTING!
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>

        <!--End Hosting-->
        <b-modal ref="modal-end-hosting" title="End Selected Hostings" hide-footer>
            <b-container>
                <b-form @submit="EndHostings">
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Hosting End Date:</label>
                                <flat-pickr v-model="EffectiveDate" class="form-control" required :config="DateConfig"></flat-pickr>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelEndHosting()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                END HOSTING
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>

        <!--Delete Hosting-->
        <b-modal ref="modal-delete-hosting" title="DELETE Selected Hostings" hide-footer>
            <b-container>
                <b-form @submit="DeleteHostings">
                    <b-row>
                        <h3 class="red">WARNING</h3>
                        <p>You are about to DELETE the Selected Hosting Records.  This makes it as if the Hosting never happened.  Typically this should only be done if the Hosting was added my mistake.</p>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelDeleteHosting()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="danger" type="submit">
                                DELETE
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
    //Import Components
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';
    //Import Services
    import { EventBus } from '../../../../../services/event-bus.js';

    export default {
        name: "Hosting",
        props: [
            'RecordData'
        ],
        data: function () {
            return {
                Hostings: [],
                UnhostedChildren: [],
                TargetResourceFamily: {},
                EffectiveDate: null,
                HostFamilyOptions: [],
                HostFamilyOptionsDataAccess: [],
                ChurchContacts: [],
                //AUX
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y'
                }
            }
        },
        methods: {
            //API
            HostSelectedChildren(e) {
                e.preventDefault();
                //build list of selected clients
                let clientIDs = [];
                this.UnhostedChildren.forEach(function (client) {
                    if (client.Checked) {
                        clientIDs.push(client.Id);
                    }
                    
                });
                this.$MasterAPI.ExecuteRequest("POST", "StrongFamilies/Hostings", { ReferralID: this.RecordData.Id, ClientIDs: clientIDs, StartDate: this.EffectiveDate, FosterResourceFamilyID: this.TargetResourceFamily.TargetFosterResourceFamily  }, this.HostSelectedChildrenSuccess, () => { }, true);
            },
            HostSelectedChildrenSuccess(response) {
                this.$GlobalUpdate.ExecuteGlobalUpdate(this.RecordData.Id);
                this.GetUnhostedChildren();
                this.GetHostings();
                this.$refs['modal-start-hosting'].hide();
            },
            EndHostings(e) {
                e.preventDefault();
                //build list of selected clients
                let hostingIDs = [];
                this.CurrentHostings.forEach(function (hosting) {
                    if (hosting.Checked) {
                        hostingIDs.push(hosting.Id);
                    }

                });
                this.$MasterAPI.ExecuteRequest("PATCH", "StrongFamilies/Hostings/EndHosting", { HostingIDs: hostingIDs, EndDate: this.EffectiveDate }, this.EndHostingsSuccess, () => { }, true);
            },
            EndHostingsSuccess(response) {
                this.$GlobalUpdate.ExecuteGlobalUpdate(this.RecordData.Id);
                this.GetUnhostedChildren();
                this.GetHostings();
                this.$refs['modal-end-hosting'].hide();
            },
            DeleteHostings(e) {
                e.preventDefault();
                //build list of selected clients
                let hostingIDs = [];
                this.Hostings.forEach(function (hosting) {
                    if (hosting.Checked) {
                        hostingIDs.push(hosting.Id);
                    }
                });
                this.$MasterAPI.ExecuteRequest("PATCH", "StrongFamilies/Hostings/DeleteHosting", { HostingIDs: hostingIDs }, this.DeleteHostingsSuccess, () => { }, true);
            },
            DeleteHostingsSuccess(response) {
                this.$GlobalUpdate.ExecuteGlobalUpdate(this.RecordData.Id);
                this.GetUnhostedChildren();
                this.GetHostings();
                this.$refs['modal-delete-hosting'].hide();
            },
            GetHostings() {
                this.$MasterAPI.ExecuteRequest("GET", "StrongFamilies/Hostings", { ReferralID: this.RecordData.Id }, this.GetHostingsSuccess, () => { }, true);
            },
            GetHostingsSuccess(response) {
                this.Hostings = response.data.data;
                this.GetChurchContactsForOpenHostings();
            },
            GetUnhostedChildren() {
                this.$MasterAPI.ExecuteRequest("GET", "StrongFamilies/Hostings/UnhostedChildren", { ReferralID: this.RecordData.Id }, this.GetUnhostedChildrenSuccess, () => { }, true);
            },
            GetUnhostedChildrenSuccess(response) {
                this.UnhostedChildren = response.data.data;
            },
            GetHostFamilyOptions() {
                this.$MasterAPI.ExecuteRequest("GET", "StrongFamilies/Hostings/HostFamilyOptions", { ReferralID: this.RecordData.Id }, this.GetHostFamilyOptionsSuccess, () => { }, false);
            },
            GetHostFamilyOptionsSuccess(response) {
                this.HostFamilyOptions = response.data.data;
            },
            //UI
            ShowStartHosting() {
                this.EffectiveDate = null;
                this.TargetFosterResourceFamilyID = "";
                this.TargetResourceFamily = {
                    TargetFosterResourceFamilyID: ""
                }
                this.HostFamilyOptionsDataAccess = JSON.parse(JSON.stringify(this.HostFamilyOptions));
                this.$refs['modal-start-hosting'].show();
                this.$forceUpdate();
            },
            CancelStartHosting() {
                this.$refs['modal-start-hosting'].hide();
            },
            ShowEndHosting() {
                this.EffectiveDate = null;
                this.TargetFosterResourceFamilyID = "";
                this.$refs['modal-end-hosting'].show();
            },
            CancelEndHosting() {
                this.$refs['modal-end-hosting'].hide();
            },
            ShowDeleteHosting() {
                this.EffectiveDate = null;
                this.TargetFosterResourceFamilyID = "";
                this.$refs['modal-delete-hosting'].show();
            },
            CancelDeleteHosting() {
                this.$refs['modal-delete-hosting'].hide();
            },
            //CHURCH CONTACTS
            GetChurchContactsForOpenHostings() {
                let hostFamIDs = [];
                this.CurrentHostings.forEach(function (hosting) {
                    if (hostFamIDs.includes(hosting.FosterResourceFamilyID) == false) {
                        hostFamIDs.push(hosting.FosterResourceFamilyID);
                    }
                });

                let joinedFamIDs = hostFamIDs.join(",");
                this.$MasterAPI.ExecuteRequest("GET", "StrongFamilies/Churches/ChurchContacts/ContactsForHostings", { FosterResourceFamilyIDs: joinedFamIDs }, this.GetChurchContactsForOpenHostingsSuccess, () => { }, false);

            },
            GetChurchContactsForOpenHostingsSuccess(response) {
                this.ChurchContacts = response.data.data;
            },
            //AUX
            formatDate (value, fmt = 'MM/DD/YY', defaultText = '') {
              return (value == null)
                ? defaultText
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            
        },
        components: {
            flatPickr,
            vSelect
        },
        mounted() {
            this.GetUnhostedChildren();
            this.GetHostings();
            this.GetHostFamilyOptions();
        },
        watch: {
            RecordData(newItem, oldItem) {
                if (newItem.Id != oldItem.Id) {
                    this.GetUnhostedChildren();
                    this.GetHostings();
                    this.GetHostFamilyOptions();
                }
            }
        },
        computed: {
            CurrentHostings: function () {
                return this.Hostings.filter(h => h.EndDate == null);
            },
            HostingHistory: function () {
                return this.Hostings.filter(h => h.EndDate != null);
            },
            UnhostedChecked: function () {
                return this.UnhostedChildren.filter(c => c.Checked == true).length > 0;
            },
            HostedChecked: function () {
                return this.CurrentHostings.filter(c => c.Checked == true).length > 0;
            },
            HistoryChecked: function () {
                return this.HostingHistory.filter(c => c.Checked == true).length > 0;
            },
            OperationsAllowed: function () {
                if (this.RecordData.Status == 'Open Engagement' || this.RecordData.Status == 'Hosting In Progress') {
                    return true;
                } else {
                    return false;
                }
            }
        }
    }
</script>

<style scoped>
</style>